import styled from 'styled-components';
import { TableCell } from 'ui/tableCell';
import { colors, Body2 } from 'ui/theme';

export const Wrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.values.base};
  margin-top: ${({ theme }) => theme.spacing.values.double};
`;

export const ProjectCell = styled(TableCell)<{ isOrg: boolean }>`
  min-width: ${({ theme }) => theme.spacing.utils.pxToRem(300)};
  padding-bottom: ${({ theme }) => theme.spacing.values.plusHalf};
  padding-top: ${({ theme }) => theme.spacing.values.plusHalf};
  ${({ isOrg }) => (isOrg ? `background-color: ${colors.cyan10}` : '')}
`;

export const ProjectName = styled(Body2)`
  margin-bottom: 0;
`;

export const Cell = styled(TableCell)<{ isOrg: boolean }>`
  padding-bottom: ${({ theme }) => theme.spacing.values.plusHalf};
  padding-top: ${({ theme }) => theme.spacing.values.plusHalf};
  text-align: center;
  vertical-align: middle;
  ${({ isOrg }) => (isOrg ? `background-color: ${colors.cyan10}` : '')}
`;
